import { Columnz, DataTablezD } from "@/components/data_table";
import {
  Calendarz,
  GridForm,
  HeaderListForm,
  MultiSelectz,
} from "@/components/data_table/FormList";
import { useGetParams } from "@/hooks";
import { expListLeadperDaySearch } from "@/modules/project/api";
import { useListAssignCategorySearch } from "@/modules/project/utils";
import { useListLeadperDaySearch } from "@/modules/report/utils";
import { useState } from "react";

const SearchPerDay = () => {
  const initParam = useGetParams();
  const today = new Date();
  const firstDay = new Date(today.getFullYear(), today.getMonth(), 1, 7, 0, 0);
  const lastDay = new Date(
    today.getFullYear(),
    today.getMonth() + 1,
    0,
    7,
    0,
    0
  );
  const formattedFirstDay = new Date(firstDay)
    .toISOString()
    .slice(0, 19)
    .replace("T", " ");
  const formattedLastDay = new Date(lastDay)
    .toISOString()
    .slice(0, 19)
    .replace("T", " ");
  const [params, setParams] = useState({
    ...initParam,
    from: formattedFirstDay,
    to: formattedLastDay,
  });
  const [filter, setFilter] = useState({
    ...params,
    dates: [firstDay, lastDay],
  });
  const list_category = useListAssignCategorySearch();
  const list_data = useListLeadperDaySearch({
    ...params,
    from: params?.from,
    to: params?.to,
  });
  return (
    <div className="card">
      <HeaderListForm title="Đối chiếu, tra cứu số liệu theo thời gian thực Facebook tiếp nhận" />
      <GridForm setParams={setParams} filter={filter} setFilter={setFilter}>
        <Calendarz
          className="mt-2 col-4"
          value={filter?.dates}
          onChange={(e) => setFilter({ ...filter, dates: e.value })}
          placeholder={"Chọn khoảng thời gian"}
          selectionMode="range"
        />
        {/* <MultiSelectz
          value={filter?.dates}
          onChange={(e) => setFilter({ ...filter, dates: e.value })}
          label="Sàn phân bổ (*)"
          options={list_category}
          optionValue="gb_id"
          optionLabel="gb_title"
        /> */}
        <div className="col-5"></div>
      </GridForm>
      <div className="flex flex-column">
        <div className="col-12 mx-auto flex">
          <DataTablezD
            style={{ width: "100%" }}
            title="báo cáo theo ngày"
            value={list_data?.sort(
              (a, b) =>
                new Date(b.Day.split("/").reverse().join("-")) -
                new Date(a.Day.split("/").reverse().join("-"))
            )}
            params={params}
            totalRecords={list_data?.length == 0 ? 0 : list_data?.length - 1}
            setParams={setParams}
            numRows={list_data?.length}
            basePermissions={["export"]}
            noCheckTime
            headerInfo={{
              exportApi: () => expListLeadperDaySearch(params),
            }}
          >
            <Columnz field="Day" header="Ngày" />
            {list_category?.map((e) => (
              <Columnz field={e?.cb_title} header={e?.cb_title} />
            ))}
            <Columnz field="total" header="Tổng" />
          </DataTablezD>
        </div>
      </div>
    </div>
  );
};
export default SearchPerDay;
